import axios from 'axios';

export interface News {
  id: number;
  img: string;
  title: string;
  description: string;
  channel: string;
  gec: string;
  recipients: string | null;
  status: 'activo' | 'inactivo';
}

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:7777/api/v1/back';
const AUTH_TOKEN = 'FeMsA@2024';


export const getNews = async (): Promise<News[]> => {
  try {
    const response = await axios.get(`${API_URL}/news`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${AUTH_TOKEN}`
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching news:', error);
    throw error;
  }
};

export interface CreateNewsData {
  title: string;
  description: string;
  img: string;
  channel: string;
  gec: string;
  recipients?: string;
}

export const createNews = async (newsData: CreateNewsData): Promise<News> => {
  try {
    const response = await axios.post(
      `${API_URL}/news`,
      {
        ...newsData,
        recipients: newsData.recipients || ""
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${AUTH_TOKEN}`
        }
      }
    );
    
    if (response.data.success) {
      return response.data.res;
    }
    
    throw new Error('Failed to create news');
  } catch (error) {
    console.error('Error creating news:', error);
    throw error;
  }
};

export const updateNewsStatus = async (id: number, status: 'activo' | 'inactivo'): Promise<News> => {
  try {
    const response = await axios.put(
      `${API_URL}/news/change_status`,
      { id, status },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${AUTH_TOKEN}`
        }
      }
    );
    
    if (response.data.success) {
      return response.data.res;
    }
    
    throw new Error('Failed to update news status');
  } catch (error) {
    console.error('Error updating news status:', error);
    throw error;
  }
};

export const deleteNews = async (id: number): Promise<boolean> => {
  try {
    const response = await axios.delete(
      `${API_URL}/news/${id}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${AUTH_TOKEN}`
        }
      }
    );
    
    if (response.data && response.data.success) {
      return true;
    }
    
    throw new Error(response.data?.res || 'Failed to delete news');
  } catch (error) {
    console.error('Error deleting news:', error);
    throw error;
  }
};
